<template>
  <div>
    <div class="bg-primary-300 text-white p-2">
      {{ documentData.document.title }}
    </div>
    <div class="pt-2 px-2 border-gray-200 border bg-white pb-2">
      <div class="antd-tabs mb-2">
        <nav class="antd-tabs-nav">
          <button
            type="button"
            v-for="tab in tabs"
            :key="tab.key"
            class="antd-tab"
            :class="{ 'antd-tab--active': activeTab == tab.key }"
            @click="activeTab = tab.key"
          >
            {{ tab.title }}
          </button>
        </nav>
      </div>
      <ExternalSignDocumentInfo
        v-if="activeTab === 1"
        :document-data="documentData"
      />
      <ExternalSignFiles v-if="activeTab === 2" :document-data="documentData" />
    </div>
  </div>
</template>

<script>
import ExternalSignDocumentInfo from "@/components/externalSign/ExternalSignDocumentInfo.vue";
import ExternalSignFiles from "@/components/externalSign/ExternalSignFiles.vue";
import { t } from "@/i18n";

export default {
  components: { ExternalSignFiles, ExternalSignDocumentInfo },
  props: ["documentData"],
  data: () => ({
    tabs: [
      {
        title: t("sign.tabs.documentDetails"),
        key: 1,
      },
      {
        title: t("sign.tabs.attachedFiles"),
        key: 2,
      },
    ],
    activeTab: 1,
  }),
};
</script>
